<template>
  <div>
      <Nav></Nav>
      <div class="handrs">
  <div class="w">
    <!-- <div class="mebar"></div> -->
    <div class="hands_fiend">
      <img src="../assets/img/firend.png"  ref="handsfriends" alt="">
     <!-- <a href="javascript:;"> 合作伙伴</a> -->

    </div>
     <div class="hands_img">
       <ul>
         <li>
           <img src="../assets/image/wans.png" alt="">
         </li>
          <li>
           <img src="../assets/image/funplus.png" alt="">
         </li>
          <li>
           <img src="../assets/image/le.png" alt="">
         </li>
          <li>
           <img src="../assets/image/shou.png" alt="">
         </li>
          <li>
           <img src="../assets/image/sw.png" alt="">
         </li>
          <li>
           <img src="../assets/image/six.png" alt="">
         </li>
          <li>
           <img src="../assets/image/DeNa.png" alt="">
         </li>
          <li>
           <img src="../assets/image/sy.png" alt="">
         </li>
          <li>
           <img src="../assets/image/you.png" alt="">
         </li>
          <li>
           <img src="../assets/image/lls.png" alt="">
         </li>
          <li>
           <img src="../assets/image/fen.png" alt="">
         </li>
         <li>
           <img src="../assets/image/hulai.png" alt="">
         </li>
          <li>
           <img src="../assets/image/al.png" alt="">
         </li>
          <li>
           <img src="../assets/image/bc.png" alt="">
         </li>
          <li>
           <img src="../assets/image/dy.png" alt="">
         </li>
          <li>
           <img src="../assets/image/ft.png" alt="">
         </li>
          <li>
           <img src="../assets/image/tx.png" alt="">
         </li>
          <li>
           <img src="../assets/image/BANDAI.png" alt="">
         </li>
          <li>
           <img src="../assets/image/netmarble.png" alt="">
         </li>
          <li>
           <img src="../assets/image/lj.png" alt="">
         </li>
          <li>
           <img src="../assets/image/AI.png" alt="">
         </li>
          <li>
           <img src="../assets/img/fle.png" alt="">
         </li>
          <li>
           <img src="../assets/img/fity.png" alt="">
         </li>
          <li>
           <img src="../assets/image/dayc.png" alt="">
         </li>
          <li>
           <img src="../assets/image/zi.png" alt="">
         </li>

       </ul>
      </div>
  </div>
</div>
<Footer></Footer>
  </div>
</template>

<script>
import Nav from '../components/Nav'
import Footer from '../components/Footer'

export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {

    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
  .handrs {
     background: url(../assets/img/ju.png) no-repeat;
     background-size: 100% 100%;
     position: relative;
         z-index: 33;
    top: 30px;
     .mebar {
     border-bottom: 1px solid #EBECED;
     position: absolute;
     top: 88px;
     width: 1200px;

     }

     .w {

       .hands_fiend {
         cursor: pointer;
         width: 126px;
        height: 29px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 88px;
        padding-top: 75px;
        img {
          width: 1200px;
          height: 63px;
        }
        a {

        color: #3F3F40;
        text-align: center;
        // margin-left: 460px;
        &:hover {
          border-bottom: 5px solid #046AFF;
        }
        }
       }
       .hands_img {
         margin-top: 113px;
         ul {
           width: 1160px;
           overflow: hidden;
           li {
            float: left;
             width: 230px;
               height: 105px;
                  border-right: 1px solid  #E6E6E6;
                border-bottom: 1px solid  #E6E6E6;
                padding-left: 12px;
                padding-top: 10px;

                 img {
                 width: 182px;
               height: 66px;
               cursor: pointer;
                  transition:all 1s;
               -webkit-transition:all 1s;
               -o-transition:all 1s;

                  &:hover {
                     box-sizing: border-box;
                    opacity: 1;
                   transform:scale(0.5,0.5);
                 -webkit-transform:scale(0.5,0.5);
                 -o-transform:scale(0.5,0.5);
                  }
             }
                &:nth-child(2) {
              padding-left: 12px;
              padding-top: 10px;
                  img {
                    width: 203px;
                    height: 50px;
                  }
                }
                   &:nth-child(3) {
                 padding-top: 10px;
              padding-left: 24px;
               img {
                    width: 158px;
                    height: 65px;
                  }
                }
                     &:nth-child(4) {
                      padding-top: 10px;
                        img {
                    width: 123px;
                    height: 65px;
                  }
              padding-left: 44px;
                }
                     &:nth-child(5) {
                         padding-top: 10px;
                      img {
                    width: 208px;
                    height: 62px;
                  }

                       border-right: 0;
                      padding-left: 12px;
                }

                  &:nth-child(6) {
                      img {
                    width: 179px;
                    height: 71px;
                  }
                padding-top: 18px;
                }
                   &:nth-child(7) {
                      img {
                    width: 203px;
                    height: 65px;
                  }
                  padding-top: 23px;
                }
                 &:nth-child(8) {
                      img {
                    width: 172px;
                    height: 67px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;
                }
                  &:nth-child(9) {
                      img {
                    width: 204px;
                    height: 67px;
                  }
                  padding-left: 15px;
                   padding-top: 23px;
                }
                  &:nth-child(10) {
                      img {
                    width: 206px;
                    height: 61px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;
                  border-right: 0;
                }
                 &:nth-child(11) {
                      img {
                    width: 181px;
                    height: 57px;
                  }
                  padding-left: 22px;
                  padding-top: 23px;

                }
                 &:nth-child(12) {
                   img {
                    width:206px;
                    height: 52px;
                  }
                  padding-left: 12px;
                  padding-top: 23px;

                }
                 &:nth-child(13) {
                   img {
                    width:171px;
                    height: 45px;
                  }
                  padding-left: 22px;
                   padding-top: 26px;

                }
                 &:nth-child(14) {
                   img {
                    width:184px;
                    height: 57px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;

                }
                 &:nth-child(15) {
                   img {
                    width:204px;
                    height: 53px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;
                  border-right: 0;
                }
                 &:nth-child(16) {
                   img {
                    width:176px;
                    height: 63px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;

                }
                 &:nth-child(17) {
                   img {
                    width:206px;
                    height: 59px;
                  }
                  padding-left: 15px;
                  padding-top: 23px;

                }
                 &:nth-child(18) {
                   img {
                    width:81px;
                    height: 88px;
                  }
                  padding-left: 68px;
                  padding-top: 10px;

                }
                 &:nth-child(19) {
                   img {
                    width:88px;
                    height: 89px;
                  }
                  padding-left: 68px;
                  padding-top: 10px;

                }
                 &:nth-child(20) {
                   img {
                    width:172px;
                    height: 98px;
                  }
                  padding-left: 35px;
                  padding-top: 6px;
                   border-right: 0;
                }
                 &:nth-child(21) {
                   img {
                    width:179px;
                    height: 73px;
                  }
                  padding-left: 28px;
                  padding-top: 12px;

                }
                 &:nth-child(22) {
                   img {
                    width:178px;
                    height: 72px;
                  }
                  padding-left: 28px;
                  padding-top: 12px;

                }
                 &:nth-child(23) {
                   img {
                    width:205px;
                    height: 44px;
                  }
                  padding-left: 11px;
                  padding-top: 25px;

                }
                 &:nth-child(24) {
                   img {
                    width:138px;
                    height: 86px;
                  }
                  padding-left: 32px;
                  padding-top: 12px;

                }
                 &:nth-child(25) {
                   img {
                    width:138px;
                    height: 86px;
                  }
                  padding-left: 40px;
                  padding-top: 12px;
                  border-right: 0;

                }

           }
         }
       }
     }
   }
</style>
